import { render, staticRenderFns } from "./EventOverView.vue?vue&type=template&id=287bcd1a&scoped=true&"
import script from "./EventOverView.vue?vue&type=script&lang=js&"
export * from "./EventOverView.vue?vue&type=script&lang=js&"
import style0 from "./EventOverView.vue?vue&type=style&index=0&id=287bcd1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287bcd1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VChip } from 'vuetify/lib/components/VChip';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VChip,VFlex,VLayout})
